import React from 'react';
import { BookOpenIcon, HeartIcon, StethoscopeIcon, ArrowRightIcon, ShieldIcon, LeafIcon } from 'lucide-react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
const features = ['Pago 100% seguro', 'Recibo inmediato por email', 'Puedes elegir el monto'];
function FeatureItem({
  text
}: {
  text: string;
}) {
  return <li className="flex items-start gap-2" data-id="element-222" data-mp="1e4xfawfb6lp2">
      <span style={{
      color: '#7DC920',
      fontWeight: 700
    }} data-id="element-223" data-mp="2brec80k4qxaa">
        ✓
      </span>
      <span data-id="element-224" data-mp="26t31zopxakrj">{text}</span>
    </li>;
}
const impactItems = [{
  icon: BookOpenIcon,
  title: 'Educación',
  text: 'Recursos y guías para familias'
}, {
  icon: HeartIcon,
  title: 'Nutrición',
  text: 'Planes antiinflamatorios'
}, {
  icon: StethoscopeIcon,
  title: 'Especialistas',
  text: 'Acceso a medicina biomédica'
}];
export function Donar() {
  useDocumentMeta({
    title: 'Donar | Pancita Feliz Foundation',
    description: 'Tu donación transforma vidas. Apoya a Pancita Feliz Foundation y ayuda a familias con necesidades de neurodesarrollo.',
    path: '/donar'
  });
  return <main className="w-full" data-id="element-225" data-mp="30u3p1wxcftxy">
      {/* Hero */}
      <section className="text-center" style={{
      background: 'linear-gradient(135deg, #1a3a0a 0%, #2d5a1b 100%)',
      padding: '80px 20px 60px',
      color: 'white'
    }} data-id="element-226" data-mp="2m3whic8vjvc1">
        <img src="https://cdn.magicpatterns.com/uploads/wpdp43pGEjSRNDR3FLVv4Q/pancita_feliz.png" alt="Pancita Feliz Foundation" className="mp-donar-hero-logo" style={{
        height: 'auto',
        objectFit: 'contain',
        display: 'block',
        margin: '0 auto 32px auto',
        filter: 'brightness(0) invert(1)'
      }} data-id="element-227" data-mp="2d1n51gu1prw0" />
        <p style={{
        fontSize: '13px',
        color: '#a8e063',
        letterSpacing: '3px',
        fontWeight: 600,
        textTransform: 'uppercase',
        marginBottom: '12px'
      }} data-id="element-228" data-mp="1doz0hj6it1e">
          Tu Donación Transforma Vidas
        </p>
        <h1 className="mp-donar-title" style={{
        fontWeight: 700,
        color: 'white',
        marginBottom: '16px'
      }} data-id="element-229" data-mp="3vzt7qw5rr1y8">
          Sé Parte del Cambio
        </h1>
        <p style={{
        fontSize: '18px',
        color: 'rgba(255,255,255,0.85)',
        maxWidth: '580px',
        margin: '0 auto 40px'
      }} data-id="element-230" data-mp="3m5azretbkk8m">
          Cada donación permite que una familia acceda a educación, nutrición y
          medicina biomédica que transforma el neurodesarrollo de sus hijos.
        </p>
      </section>

      {/* Donation cards */}
      <section className="mp-donar-body" style={{
      background: '#f8faf5',
      padding: '60px 20px'
    }} data-id="element-231" data-mp="16bsoinxjhxup">
        <div className="mp-donar-cards" style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '24px',
        maxWidth: '700px',
        margin: '0 auto'
      }} data-id="element-232" data-mp="11jizrb85v3u0">
          {/* Card 1: Stripe */}
          <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '40px 32px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          borderTop: '4px solid #635BFF',
          textAlign: 'center'
        }} data-id="element-233" data-mp="1itd2odhhhgv4">
            <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #635BFF 0%, #8B7FFF 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px auto',
            boxShadow: '0 8px 24px rgba(99,91,255,0.35)'
          }} data-id="element-234" data-mp="1wsuxpaldhqcx">
              <img src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg" alt="Stripe" style={{
              width: '60px',
              height: 'auto',
              objectFit: 'contain',
              filter: 'brightness(0) invert(1)'
            }} data-id="element-235" data-mp="3d90j0kcoahfu" />
            </div>
            <h2 style={{
            fontSize: '22px',
            fontWeight: 700,
            color: '#1a1a1a',
            marginBottom: '8px'
          }} data-id="element-236" data-mp="2ua60d0a38wue">
              Donar con Tarjeta
            </h2>
            <p style={{
            fontSize: '14px',
            color: '#666',
            marginBottom: '20px'
          }} data-id="element-237" data-mp="33cozb9ar6pbd">
              Visa, Mastercard, American Express
            </p>
            <ul className="space-y-2" style={{
            fontSize: '14px',
            color: '#555',
            textAlign: 'left',
            marginBottom: '28px'
          }} data-id="element-238" data-mp="ejtii0tyzyi0">
              <FeatureItem text="Pago 100% seguro" data-id="element-239" data-mp="r3qkgk6csm3e" />
              <FeatureItem text="Procesado por Stripe" data-id="element-240" data-mp="c54vukedkw3w" />
              <FeatureItem text="Recibo inmediato por email" data-id="element-241" data-mp="c6pog4h4q4z4" />
              <FeatureItem text="Puedes elegir el monto" data-id="element-242" data-mp="h36h9bz9x7ij" />
            </ul>
            <a href="https://buy.stripe.com/cNicN585Zb7B3Dd6Ns00000" target="_blank" rel="noopener noreferrer" className="mp-stripe-btn mp-donar-btn flex items-center justify-center gap-2" style={{
            background: '#635BFF',
            color: 'white',
            width: '100%',
            height: '52px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: 700,
            border: 'none',
            cursor: 'pointer',
            textDecoration: 'none'
          }} data-id="element-243" data-mp="14tu18vmgrnlg">
              Donar con Tarjeta
              <ArrowRightIcon className="mp-donar-arrow" size={18} data-id="element-244" data-mp="22cr4txxzs5lk" />
            </a>
          </div>

          {/* Card 2: PayPal */}
          <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '40px 32px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          borderTop: '4px solid #009cde',
          textAlign: 'center'
        }} data-id="element-245" data-mp="1tdxayfc1ptbp">
            <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #009cde 0%, #003087 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px auto',
            boxShadow: '0 8px 24px rgba(0,156,222,0.35)'
          }} data-id="element-246" data-mp="1epal3joslj68">
              <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" style={{
              width: '60px',
              height: 'auto',
              objectFit: 'contain',
              filter: 'brightness(0) invert(1)'
            }} data-id="element-247" data-mp="37ea9f7610jga" />
            </div>
            <h2 style={{
            fontSize: '22px',
            fontWeight: 700,
            color: '#1a1a1a',
            marginBottom: '8px'
          }} data-id="element-248" data-mp="3lbp2qmzehbdj">
              Donar con PayPal
            </h2>
            <p style={{
            fontSize: '14px',
            color: '#666',
            marginBottom: '20px'
          }} data-id="element-249" data-mp="2xnyw4u0gcxwq">
              Saldo PayPal o tarjeta vinculada
            </p>
            <ul className="space-y-2" style={{
            fontSize: '14px',
            color: '#555',
            textAlign: 'left',
            marginBottom: '28px'
          }} data-id="element-250" data-mp="25wsprvu523z0">
              <FeatureItem text="Pago 100% seguro" data-id="element-251" data-mp="ycqunjur1z85" />
              <FeatureItem text="Procesado por PayPal" data-id="element-252" data-mp="ye1vpbwt8svk" />
              <FeatureItem text="Recibo inmediato por email" data-id="element-253" data-mp="1d9rnjqoog087" />
              <FeatureItem text="Puedes elegir el monto" data-id="element-254" data-mp="1d757f2nq0ced" />
            </ul>
            <a href="https://www.paypal.com/ncp/payment/7MR2476FEM7HC" target="_blank" rel="noopener noreferrer" className="mp-paypal-btn mp-donar-btn flex items-center justify-center gap-2" style={{
            background: '#009cde',
            color: 'white',
            width: '100%',
            height: '52px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: 700,
            border: 'none',
            cursor: 'pointer',
            textDecoration: 'none'
          }} data-id="element-255" data-mp="1893l88uzzwyo">
              Donar con PayPal
              <ArrowRightIcon className="mp-donar-arrow" size={18} data-id="element-256" data-mp="2joo2ipmp7jre" />
            </a>
          </div>
        </div>

        {/* Trust section */}
        <div style={{
        marginTop: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px',
        flexWrap: 'wrap'
      }} data-id="element-257" data-mp="2ok3d98peszjl">
          {[{
          icon: ShieldIcon,
          label: 'Pagos 100% seguros'
        }, {
          icon: LeafIcon,
          label: 'Fundación registrada'
        }, {
          icon: HeartIcon,
          label: 'Tu donación hace la diferencia'
        }].map(({
          icon: Icon,
          label
        }) => <span key={label} style={{
          fontSize: '13px',
          color: '#555',
          fontWeight: 500,
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }} data-id="element-258" data-mp="1hxhbo26s43nw">
              <Icon size={16} color="#7DC920" data-id="element-259" data-mp="1pbjmzb2d0z0g" />
              {label}
            </span>)}
        </div>

        {/* Impact section */}
        <div style={{
        background: 'white',
        borderRadius: '16px',
        maxWidth: '700px',
        margin: '40px auto 0',
        padding: '32px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.06)'
      }} data-id="element-260" data-mp="1bctrfzv6v7e7">
          <h3 style={{
          fontSize: '20px',
          fontWeight: 700,
          color: '#1a1a1a',
          textAlign: 'center',
          marginBottom: '24px'
        }} data-id="element-261" data-mp="28xzi8xj3dz55">
            ¿A dónde va tu donación?
          </h3>
          <div className="mp-donar-impact" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '20px',
          textAlign: 'center'
        }} data-id="element-262" data-mp="2myaao501vlsf">
            {impactItems.map(({
            icon: Icon,
            title,
            text
          }) => <div key={title} className="flex flex-col items-center" data-id="element-263" data-mp="bc8ctpeeorvj">
                <Icon size={32} color="#7DC920" data-id="element-264" data-mp="p2lnw0mlgmp3" />
                <p style={{
              fontSize: '15px',
              fontWeight: 600,
              color: '#1a1a1a',
              margin: '8px 0 4px'
            }} data-id="element-265" data-mp="p2bwq9ptc9ht">
                  {title}
                </p>
                <p style={{
              fontSize: '13px',
              color: '#666'
            }} data-id="element-266" data-mp="3oj0bzah77dj0">
                  {text}
                </p>
              </div>)}
          </div>
        </div>
      </section>
    </main>;
}